import cogoToast from 'cogo-toast';
import { trackAddToWishlist, trackRemoveFromWishlist } from '../../helpers/analytics';
const { createSlice } = require('@reduxjs/toolkit');

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState: {
        wishlistItems: []
    },
    reducers: {
        addToWishlist(state, action) {
            const isInWishlist = state.wishlistItems.findIndex(item => item.id === action.payload.id);
            if(isInWishlist > -1){
                cogoToast.info("Product already in wishlist", {position: "bottom-left"});
            } else {
                state.wishlistItems.push(action.payload);
                cogoToast.success("Added To wishlist", {position: "bottom-left"});

                // Track add to wishlist in Google Analytics
                trackAddToWishlist(action.payload);
            }

        },
        deleteFromWishlist(state, action){
            const itemToRemove = state.wishlistItems.find(item => item.id === action.payload);
            state.wishlistItems = state.wishlistItems.filter(item => item.id !== action.payload);
            cogoToast.error("Removed From Wishlist", {position: "bottom-left"});

            // Track remove from wishlist in Google Analytics
            if (itemToRemove) {
                trackRemoveFromWishlist(itemToRemove);
            }
        },
        deleteAllFromWishlist(state){
            state.wishlistItems = []
        }
    },
});

export const { addToWishlist, deleteFromWishlist, deleteAllFromWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
